import { useState, useEffect } from "react";
import { supabase } from "../supabase";
import "../App.css";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


export default function AdminDashboard() {
  const copyOrderInfo = (o) => {
  const text = `
Commande: ${o.order_code}
Client: ${o.client_name} (${o.phone})
Destinataire: ${o.recipient_name} (${o.recipient_phone})
Type Colis: ${o.package_type}
Valeur Colis: ${o.package_price} FCFA
Prix Livraison: ${o.price} FCFA
Collecte: ${o.pickup}
Livraison: ${o.delivery}
Paiement: ${o.payment_method}
Payé par: ${o.delivery_fee_payer}
Statut: ${o.status}
Livreur: ${o.driver?.email || "Non assigné"}
Date: ${new Date(o.created_at).toLocaleString("fr-FR")}
`;

  navigator.clipboard.writeText(text)
    .then(() => alert("Infos de la commande copiées !"))
    .catch((err) => console.error("Impossible de copier :", err));
};
  const [editedDelivery, setEditedDelivery] = useState({});
  const [editedPrice, setEditedPrice] = useState({});
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [user, setUser] = useState(null);
  const [editedNote, setEditedNote] = useState({});
  const [orders, setOrders] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [searchPhone, setSearchPhone] = useState("");
  const [view, setView] = useState("new");
  const updateDelivery = async (id) => {
  const value = editedDelivery[id];
  
  const { error } = await supabase
    .from("orders")
    .update({ delivery: value })
    .eq("id", id);

  if (!error) {
    setEditedDelivery((prev) => {
      const copy = { ...prev };
      delete copy[id];
      return copy;
    });
  }
};
  const updatePrice = async (id) => {
  const value = editedPrice[id];

  const { error } = await supabase
    .from("orders")
    .update({ price: value })
    .eq("id", id);

  if (!error) {
    setEditedPrice((prev) => {
      const copy = { ...prev };
      delete copy[id];
      return copy;
    });
  }
};
const updateStatus = async (orderId, status) => {
  await supabase
    .from("orders")
    .update({
      status: status,
      completed_at:
        status === "Terminé" ? new Date().toISOString() : null,
    })
    .eq("id", orderId);
};
const exportExcel = () => {
  const data = filteredOrders.map((o) => ({
    Date: new Date(o.created_at).toLocaleString("fr-FR"),
    Commande: o.order_code,
    Client: o.client_name,
    Téléphone: o.phone,
    Destinataire: o.recipient_name,
    "Tél Dest.": o.recipient_phone,
    Collecte: o.pickup,
    Livraison: o.delivery,
    "Prix livraison": o.price,
    "Valeur colis": o.package_price,
    Paiement: o.payment_method,
    "Payé par": o.delivery_fee_payer,
    Statut: o.status,
    Livreur: o.driver?.email || "Non assigné",
    Note: o.note || "",
  }));

  const worksheet = XLSX.utils.json_to_sheet(data);

  worksheet["!cols"] = [
    { wch: 18 },
    { wch: 15 },
    { wch: 20 },
    { wch: 15 },
    { wch: 20 },
    { wch: 15 },
    { wch: 25 },
    { wch: 25 },
    { wch: 15 },
    { wch: 15 },
    { wch: 15 },
    { wch: 15 },
    { wch: 12 },
    { wch: 25 },
    { wch: 40 },
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Commandes");

  XLSX.writeFile(workbook, "watamin_commandes.xlsx");
};
const exportPDF = () => {

  const doc = new jsPDF();

  doc.text("Watamin Livraison - Commandes", 7, 7);
  

  const tableColumn = [
    "Date",
    "Commande",
    "Client",
    "Téléphone",
    "Collecte",
    "Livraison",
    "Prix livraison",
    "Valeur colis",
    "Statut"
  ];

  const tableRows = [];

  orders.forEach((o) => {
    const row = [
      new Date(o.created_at).toLocaleString(),
      o.order_code,
      o.client_name,
      o.phone,
      o.pickup,
      o.delivery,
      o.price,
      o.package_price,
      o.status
    ];

    tableRows.push(row);
  });

  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
  });

  doc.save("watamin_commandes.pdf");
};

  /* =======================
     AUTH
  ======================= */
  useEffect(() => {
  const checkUser = async () => {
    const { data } = await supabase.auth.getSession();
    const sessionUser = data?.session?.user;

    if (!sessionUser) {
      setUser(null);
      return;
    }

    // fetch the profile to check role
    const { data: profile, error } = await supabase
      .from("profiles")
      .select("id, role")
      .eq("id", sessionUser.id)
      .single();

    if (error || !profile) {
      await supabase.auth.signOut();
      setUser(null);
      alert("Erreur : profil introuvable");
      return;
    }

    if (profile.role !== "admin") {
      await supabase.auth.signOut();
      setUser(null);
      alert("Accès refusé : vous n'êtes pas administrateur");
      return;
    }

    // user is admin
    setUser(sessionUser);
    fetchDrivers();
  };

  checkUser();
}, []);

  useEffect(() => {
    if (!user) return;

    fetchOrders();
    fetchDrivers();

    const channel = supabase
      .channel("orders-realtime")
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "orders" },
        fetchOrders
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [user]);

 const handleLogin = async () => {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });

  if (error) {
    setErrorMsg(error.message);
    return;
  }

  // Fetch the user's profile
  const { data: profile, error: profileError } = await supabase
    .from("profiles")
    .select("*")
    .eq("id", data.user.id)
    .single();

  if (profileError) {
    setErrorMsg("Erreur lors de la récupération du profil.");
    return;
  }

  if (profile.role !== "admin") {
    setErrorMsg("Accès refusé : compte non administrateur.");
    await supabase.auth.signOut();
    return;
  }

  setUser(data.user);
  setErrorMsg("");
};



  const handleLogout = async () => {
    await supabase.auth.signOut();
    setUser(null);
    setOrders([]);
  };

  /* =======================
     DATA
  ======================= */
  const fetchOrders = async () => {
    const { data, error } = await supabase
      .from("orders")
      .select(`
  *,
  driver:driver_id(id,email)
`)
      .order("created_at", { ascending: false });

    if (!error) setOrders(data || []);
  };

  const fetchDrivers = async () => {
    const { data, error } = await supabase
      .from("profiles")
      .select("*")
      .eq("role", "driver");
      console.log("Drivers:", data, error);

    setDrivers(data || []);
  };

  const reassignOrder = async (orderId, driverId) => {
    await supabase.from("orders").update({ driver_id: driverId }).eq("id", orderId);
  };
  const updateNote = async (id) => {
  const value = editedNote[id];

  const { error } = await supabase
    .from("orders")
    .update({ note: value })
    .eq("id", id);

  if (!error) {
    setEditedNote((prev) => {
      const copy = { ...prev };
      delete copy[id];
      return copy;
    });
  }
};
  const filteredOrders = orders
  .filter((o) =>
    o.recipient_phone?.includes(searchPhone) || o.delivery?.toLowerCase().includes(searchPhone.toLowerCase())
  )
  .filter((o) => (view === "new" ? !o.driver_id : true));
  const ordersByDriver = orders.reduce((acc, order) => {
  const key = order.driver?.id || "unassigned";

  if (!acc[key]) acc[key] = [];
  acc[key].push(order);

  return acc;
},
 {});
 const ordersByClient = orders.reduce((acc, order) => {
  const key = order.client_name || "Client inconnu";

  if (!acc[key]) acc[key] = [];
  acc[key].push(order);

  return acc;
}, {});
const renderOrdersRows = (ordersList) =>
  ordersList.map((o) => (
      <tr key={o.id}>
      <td>
    <button
      className="third"
      onClick={() => copyOrderInfo(o)}
    >
      Copier
    </button>
  </td>
        <td>
  {new Intl.DateTimeFormat("fr-FR", {
    timeZone: "Africa/Ouagadougou",
    dateStyle: "short",
    timeStyle: "short",
  }).format(new Date(o.created_at))}
</td>

        <td>{o.order_code}</td>
        <td>{o.phone}</td>
        <td>{o.client_name}</td>
        <td>{o.recipient_name}</td>
        <td>{o.recipient_phone}</td>
        <td>{o.package_type}</td>
        <td>{o.package_price} FCFA</td>
        <td>{o.pickup}</td>
        <td>
  <input 
  value={editedDelivery[o.id] ?? o.delivery  ?? ""}
  onChange={(e) =>
    setEditedDelivery({
      ...editedDelivery,
      [o.id]: e.target.value,
    })
  }
/>
<button className="secondary"
  onClick={() => updateDelivery(o.id)}
>
  Enregistrer
</button>
</td>
 <td></td>
<td>
  <input
    value={editedPrice[o.id] ?? o.price ?? ""}
    onChange={(e) =>
      setEditedPrice({
        ...editedPrice,
        [o.id]: e.target.value,
      })
    }
    style={{ width: "80px" }}
  />

  <button
    className="secondary"
    onClick={() => updatePrice(o.id)}
  >
    Enregistrer
  </button>
</td>
        <td>{o.delivery_fee_payer} </td>
        <td>{o.payment_method}</td>
        <td>{o.status}</td>
        <td>{o.driver?.email || "Non assigné"}</td>
        <td>
          <select
            value={o.driver_id || ""}
            onChange={(e) => reassignOrder(o.id, e.target.value)}
          >
            <option value="">Choisir</option>
            {drivers.map((d) => (
              <option key={d.id} value={d.id}>
                {d.email}
              </option>
            ))}
          </select>
        </td>
        <td>
  <textarea
  className="NoteInput"
  value={editedNote[o.id] ?? o.note ?? ""}
  onChange={(e) =>
    setEditedNote({
      ...editedNote,
      [o.id]: e.target.value,
    })
  }
/>
  <button
    className="secondary"
    onClick={() => updateNote(o.id)}
  >
    Enregistrer
  </button>
</td>
        <td>{o.completed_at}</td>
        <td>

  <button
    className="secondary"
    onClick={() => updateStatus(o.id, "En cours")}
  >
    En cours
  </button>
  <button
    className="secondary"
    onClick={() => updateStatus(o.id, "Terminé")}
  >
    Terminer
  </button>
  
  <button
    className="secondary"
    onClick={() => updateStatus(o.id, "Annulé")}
  >
    Annuler
  </button>
</td>
        
      </tr>
    ));



  /* =======================
     LOGIN SCREEN
  ======================= */
  if (!user) {
    return (
      <div className="admin-container">
        <div className="card admin-card">
          <h2 className="admin-title">Panel Administrateur</h2>

          {errorMsg && <p className="error">{errorMsg}</p>}

          <div className="field">
            <label>Email</label>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@example.com"
            />
          </div>

          <div className="field">
            <label>Mot de passe</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="********"
            />
          </div>

          <button className="login-btn" onClick={handleLogin}>
            Connexion
          </button>
        </div>
      </div>
    );
  }

  /* =======================
     DASHBOARD
  ======================= */
  return (
    <div className="admin-page">
      <header className="topbar">
        <h1 className="topbar-title">Watamin • Administrateur</h1>

        <div className="search-box">
  <input
    className="search-input"
    placeholder="téléphone ou Adresse"
    value={searchPhone}
    onChange={(e) => setSearchPhone(e.target.value)}
  />

  <button
    className="primary search-btn"
    onClick={() => {}}
  >
    Rechercher
  </button>
</div>


        <button className="ghost" onClick={() => setView("new")}>
          Nouvelles commandes
        </button>

        <button className="ghost" onClick={() => setView("all")}>
          Historique commandes
        </button>
        <button className="ghost" onClick={() => setView("byDriver")}>
        livreurs
        </button>
        <button className="ghost" onClick={() => setView("byClient")}>
        Clients
        </button>
        <button className="primary" onClick={exportExcel}>
        Telecharger le Tableau
        </button>


        <button className="ghost logout-btn" onClick={handleLogout}>
          Déconnexion
        </button>
      </header>

      <main className="admin-content">
  {view !== "byDriver" && view !== "byClient" ? (
  <table className="orders-table">
    <thead>
      <tr>
        <th>Transfert</th>
        <th>Date</th>
        <th>N°</th>
        <th>Tél. client</th>
        <th>Nom Client</th>
        <th>Nom Dest.</th>
        <th>Tél. Dest.</th>
        <th>Type</th>
        <th>Prix colis</th>
        <th>Collecte</th>
        <th>Livraison</th>
        <th></th>
        <th>Prix</th>
        <th>Payé par</th>
        <th>Paiement</th>
        <th>Statut</th>
        <th>Livreur</th>
        <th>Réassigner</th>
        <th>Note</th>
        <th>Terminé a</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>{renderOrdersRows(filteredOrders)}</tbody>
  </table>
) : view === "byDriver" ? (
  Object.entries(ordersByDriver).map(([driverId, driverOrders]) => {
    const driver = drivers.find((d) => String(d.id) === String(driverId)) || null;

    return (
      <div key={driverId} className="admin-section" style={{ marginBottom: 32 }}>
        <h2 className="section-title">
          {driver ? `Livreur : ${driver.email}` : "Commandes non assignées"} ({driverOrders.length})
        </h2>

        <div className="table-wrapper">
          <table className="orders-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>N°</th>
                <th>Client</th>
                <th>Livraison</th>
                <th>Prix</th>
                <th>Statut</th>
                <th>Réassigner</th>
                <th>Terminé a</th>
              </tr>
            </thead>
            <tbody>
              {driverOrders.map((o) => (
                <tr key={o.id}>
                  <td>
                    {new Intl.DateTimeFormat("fr-FR", {
                      timeZone: "Africa/Ouagadougou",
                      dateStyle: "short",
                      timeStyle: "short",
                    }).format(new Date(o.created_at))}
                  </td>
                  <td>{o.order_code}</td>
                  <td>{o.client_name}</td>
                  <td>{o.delivery}</td>
                  <td>{o.price} FCFA</td>
                  <td>{o.status}</td>
                  <td>
                    <select
                      value={o.driver_id || ""}
                      onChange={(e) => reassignOrder(o.id, e.target.value)}
                    >
                      <option value="">Choisir</option>
                      {drivers.map((d) => (
                        <option key={d.id} value={d.id}>
                          {d.email}
                        </option>
                      ))}
                    </select>
                  </td>
 
                  <td>
                    {o.completed_at
                      ? new Intl.DateTimeFormat("fr-FR", {
                          timeZone: "Africa/Ouagadougou",
                          dateStyle: "short",
                          timeStyle: "short",
                        }).format(new Date(o.completed_at))
                      : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  })
) : (
  // === byClient view ===
  Object.entries(ordersByClient).map(([clientName, clientOrders]) => (
    <div key={clientName} className="admin-section" style={{ marginBottom: 32 }}>
      <h2 className="section-title">
        {`Client : ${clientName}`} ({clientOrders.length})
      </h2>

      <div className="table-wrapper">
        <table className="orders-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>N°</th>
              <th>Livraison</th>
              <th>Prix</th>
              <th>Statut</th>
              <th>Livreur</th>
            </tr>
          </thead>
          <tbody>
            {clientOrders.map((o) => (
              <tr key={o.id}>
                <td>
                  {new Intl.DateTimeFormat("fr-FR", {
                    timeZone: "Africa/Ouagadougou",
                    dateStyle: "short",
                    timeStyle: "short",
                  }).format(new Date(o.created_at))}
                </td>
                <td>{o.order_code}</td>
                <td>{o.delivery}</td>
                <td>{o.price} FCFA</td>
                <td>{o.status}</td>
                <td>{o.driver?.email || "Non assigné"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  ))
)}
  
</main>

    </div>
  );
}


